<template>
  <e-chart
    :header="`${documentTitle}`"
    :options="chartGeneratedTkoOptions"
    :series="chartGeneratedTkoSeries"
    class="item-large"
    chartId="generatedTko"
    :chartRedirectParams="chartRedirectParams"
    :chartLoading="chartLoading"
    :chartError="chartError"
    :alwaysDisableAnimation="true"
  >
    <template slot="exportData">
      <div class="chart-block__export-data">
        <div>{{ documentTitle }}</div>
        <div>Период: {{ fields.formStart }} - {{ fields.formEnd }}</div>
      </div>
    </template>
    <template slot="chartHeader">
      <div class="default-select part-1-from-4">
        <label for="" class="label semibold">Выбор диапазона</label>
        <div class="display-flex chart-block__wide-select">
          <e-select
            @change="fetchData"
            tabView="tab1"
            :model="fields"
            name="formStart"
            :options="chartYearOptions"
          ></e-select>
          <e-select
            @change="fetchData"
            tabView="tab1"
            :model="fields"
            name="formEnd"
            :options="chartYearOptions"
          ></e-select>
        </div>
      </div>
    </template>
  </e-chart>
</template>
<script>
import chartsMixin from '../mixins/charts-mixin'
import { analytic } from '@/api/api-endpoints'

export default {
  mixins: [chartsMixin],
  props: { limit: { type: Number, default: null } },
  data() {
    return {
      categoriesYears: {},
    }
  },
  computed: {
    getCurrentChartOptions() {
      return this.getChartOptions('generatedTko')
    },
  },
  methods: {
    buildEndpoint() {
      const years = [this.fields.formStart]
      if (this.fields.formEnd) {
        years.push(this.fields.formEnd)
      }
      return analytic.generatedTko({
        query: {
          years,
        },
      })
    },
    fetchData() {
      this.fetchChartData().then((r) => {
        this.chartGeneratedTkoSeries = this.transform(r)
        this.createAndSetCats(r, this.chartGeneratedTkoSeries)
      })
    },
    transform(data) {
      const result = []
      this.categoriesYears = {}
      // при первом проходе через данные формруем года
      data.data.forEach((item) => {
        for (let i = this.fields.formStart; i <= this.fields.formEnd; i++) {
          if (Number(item.year) === i) {
            if (
              item.regional_cadastre_form2.generated_waste_amount ||
              item.two_tp_waste_form2.generated_waste_amount ||
              item.order_285.generated_waste_amount ||
              item.electronic_waste.generated_waste_amount
            ) {
              this.$set(this.categoriesYears, item.year, {
                regional_cadastre_form2: [],
                two_tp_waste_form2: [],
                order_285: [],
                electronic_waste: [],
              })
            }
          }
        }
      })

      // при втором проходе заносим данные для каждого года
      data.data.forEach((item) => {
        for (let i = this.fields.formStart; i <= this.fields.formEnd; i++) {
          if (item.year == i && this.categoriesYears[item.year]) {
            this.categoriesYears[i].regional_cadastre_form2 = item
              .regional_cadastre_form2?.generated_waste_amount
              ? Number(item.regional_cadastre_form2.generated_waste_amount)
              : 0

            this.categoriesYears[i].two_tp_waste_form2 = item.two_tp_waste_form2
              ?.generated_waste_amount
              ? Number(item.two_tp_waste_form2.generated_waste_amount)
              : 0

            this.categoriesYears[i].order_285 = item.order_285
              ?.generated_waste_amount
              ? Number(item.order_285.generated_waste_amount)
              : 0

            this.categoriesYears[i].electronic_waste = item.electronic_waste
              ?.generated_waste_amount
              ? Number(item.electronic_waste.generated_waste_amount)
              : 0
          }
        }
      })
      const sumUpByAttrubute = (attr) => {
        return Object.values(this.categoriesYears).reduce((acc, item) => {
          acc.push(item[attr])
          return acc
        }, [])
      }
      result.push({
        type: 'column',
        name: 'регкадастр',
        data: sumUpByAttrubute('regional_cadastre_form2'),
      })

      result.push({
        type: 'column',
        name: '2-ТП',
        color: 'orange',
        data: sumUpByAttrubute('two_tp_waste_form2'),
      })

      result.push({
        type: 'column',
        name: 'приказ 285',
        color: 'grey',
        data: sumUpByAttrubute('order_285'),
      })

      result.push({
        type: 'line',
        name: 'Расчетные данные',
        data: sumUpByAttrubute('electronic_waste'),
      })

      return result
    },
    createAndSetCats() {
      let options = Object.assign({}, this.chartGeneratedTkoOptions)
      options.xAxis.categories = Object.keys(this.categoriesYears)
      this.chartGeneratedTkoOptions = Object.assign({}, options)
    },
  },
  created() {
    this.chartGeneratedTkoOptions = this.getCurrentChartOptions
    this.fetchData()
  },
}
</script>
<style>
.highcharts-credits {
  display: none;
}

.chart-block__wide-select {
  gap: 10px;
}
</style>
